// extracted by mini-css-extract-plugin
module.exports = {"screen":"Splash_screen__3hCGR","page":"Splash_page__2LMfu","inCard":"Splash_inCard__2dgAZ"};